import { render, staticRenderFns } from "./Affiliation1.container.vue?vue&type=template&id=94fb3368&scoped=true&"
import script from "./Affiliation1.container.vue?vue&type=script&lang=js&"
export * from "./Affiliation1.container.vue?vue&type=script&lang=js&"
import style0 from "./Affiliation1.container.vue?vue&type=style&index=0&id=94fb3368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb3368",
  null
  
)

export default component.exports